export default __webpack_public_path__ + "static/media/How-Node.JS-Works.7732d23e.png";